import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CreditCardIcon, TrendingUpIcon, PieChartIcon, MessageSquareIcon, HeadphonesIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  title: 'El Manual Digital Completo',
  desc: '"Generación Wealth" (PDF).'
}, {
  icon: CreditCardIcon,
  title: 'El Sistema de Blindaje de Crédito',
  desc: 'La estrategia para llegar a 700+ puntos de score sin pagar intereses.'
}, {
  icon: TrendingUpIcon,
  title: 'Guía de Inversión "Invisible"',
  desc: 'Cómo abrir y usar tu Roth IRA y 401k desde los 18 años.'
}, {
  icon: PieChartIcon,
  title: 'El Método 50/30/20',
  desc: 'Un presupuesto real que te permite divertirte sin sentir culpa.'
}, {
  icon: MessageSquareIcon,
  title: 'Guiones de Conversaciones de Poder',
  desc: 'Qué decirle a tu familia cuando el dinero se vuelve un problema.'
}, {
  icon: HeadphonesIcon,
  title: 'Audio-Training',
  desc: '65 minutos de mentalidad financiera bilingüe para escuchar en el camino al trabajo.'
}];
export function WhatYouGet() {
  return <section className="py-24 px-6 bg-[#0f0f0f]" data-id="element-165">
      <div className="max-w-6xl mx-auto" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-167">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-168">
            Lo Que Recibes
          </h2>
          <div className="w-24 h-1 bg-gold-500/50 mx-auto rounded-full" data-id="element-169" />
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-170">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="p-8 bg-dark border border-white/5 rounded-2xl hover:border-gold-500/30 transition-colors group" data-id="element-171">
                <div className="w-12 h-12 bg-white/5 rounded-xl flex items-center justify-center mb-6 group-hover:bg-gold-500/10 transition-colors" data-id="element-172">
                  <Icon className="w-6 h-6 text-gold-400" data-id="element-173" />
                </div>
                <h3 className="text-xl font-bold mb-3 text-white" data-id="element-174">
                  {item.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-175">{item.desc}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}